
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { favoritosService } from '../services/api'
import Selo from '../components/Selo'
import './MeusFavoritos.css'

function MeusFavoritos() {
    const [favoritos, setFavoritos] = useState([])
    const [loading, setLoading] = useState(true)
    const [erro, setErro] = useState(null)

    useEffect(() => {
        carregarFavoritos()
    }, [])

    const carregarFavoritos = async () => {
        setLoading(true)
        try {
            const response = await favoritosService.listar()
            setFavoritos(response.favoritos)
        } catch (error) {
            console.error('Erro ao carregar favoritos:', error)
            setErro('Não foi possível carregar seus favoritos.')
        } finally {
            setLoading(false)
        }
    }

    const formatPrice = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 0
        }).format(value)
    }

    if (loading) return <div className="loading">Carregando favoritos...</div>

    return (
        <div className="meus-favoritos">
            <div className="favoritos-header">
                <h1>⭐ Meus Favoritos</h1>
                <p>Anúncios que você salvou para ver depois.</p>
            </div>

            {erro && <div className="erro">{erro}</div>}

            {!loading && !erro && favoritos.length === 0 ? (
                <div className="empty-state">
                    <span className="empty-icon">⭐</span>
                    <h2>Você ainda não tem favoritos.</h2>
                    <p>Explore os anúncios e clique na estrela para salvar!</p>
                    <Link to="/anuncios" className="btn btn-primary" style={{ marginTop: '1rem' }}>
                        Ver Anúncios
                    </Link>
                </div>
            ) : (
                <div className="favoritos-grid">
                    {favoritos.map((anuncio) => (
                        <Link
                            key={anuncio.id}
                            to={`/anuncio/${anuncio.id}`}
                            className="favorito-card"
                        >
                            <div className="favorito-img-wrapper">
                                <img
                                    src={anuncio.imagem || anuncio.imagens?.[0]?.url_original || 'https://via.placeholder.com/400x300?text=Sem+Foto'}
                                    alt={anuncio.titulo}
                                    className="favorito-img"
                                />
                            </div>
                            <div className="favorito-content">
                                <div>
                                    <h3 className="favorito-titulo">{anuncio.titulo}</h3>
                                    <span className="favorito-local">📍 {anuncio.cidade} - {anuncio.estado}</span>
                                </div>
                                <div className="favorito-footer">
                                    <div className="favorito-preco">{formatPrice(anuncio.preco)}</div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    )
}

export default MeusFavoritos
